import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ADMIN_HOME, TEMPLATES_ROUTE_V2 } from '../constants/routePathConstants';
import { useUserContext } from '../contexts/UserContext';

const AuthGuard = ({ children }) => {
  const userCtx = useUserContext();
  const { isGuestLogin } = userCtx;
  if (!(userCtx.token && userCtx.refreshToken && userCtx.currentUser)) {
    return <Outlet />;
  } else {
    return (
      <Navigate to={isGuestLogin ? TEMPLATES_ROUTE_V2 : ADMIN_HOME} />
    );
  }
};

export default AuthGuard;
